import { render, staticRenderFns } from "./business-progress.vue?vue&type=template&id=3c3608fb&scoped=true&"
import script from "./business-progress.vue?vue&type=script&lang=js&"
export * from "./business-progress.vue?vue&type=script&lang=js&"
import style0 from "./business-progress.vue?vue&type=style&index=0&id=3c3608fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3608fb",
  null
  
)

export default component.exports